import { Injectable } from '@angular/core';
import { AttachmentsItem } from '../api/models';
import { catchError, map, of, tap } from 'rxjs';
import { AllegatiService } from '../api/services';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  _attachments: AttachmentsItem[] = [];
  toRefresh = true;
  constructor(private allegati: AllegatiService) {}

  get attachments() {
    if (!this.toRefresh && this._attachments.length > 0) {
      return of(this._attachments);
    } else {
      return this.allegati
        .attachmentsControllerGetAll({
          limit: 0,
          skip: 0,
        })
        .pipe(
          map(response => {
            this.toRefresh = false;
            this._attachments = response.data.list;
            return this._attachments;
          }),
          catchError(error => of(this._attachments))
        );
    }
  }

  refreshAttachments() {
    this.toRefresh = true;
    this.attachments.subscribe();
  }
}
